import React from 'react';

import './styles.scss';
import Icon from '../icon';
import {Icons} from '../../util/icons';
import colors from '../../util/colors';
import {createClassName} from '../../util/utility';

interface AppArrowButtonProps {
  color?: string;
  onClick(): void;
  className?: string;
  direction?: 'LEFT' | 'RIGHT';
  disabled?: boolean;
}

function AppArrowButton({
  onClick,
  className,
  color = colors.black,
  direction = 'RIGHT',
  disabled = false,
}: AppArrowButtonProps) {
  const classes = createClassName('app-arrow-button', className);

  const rotate = direction === 'RIGHT' && {transform: 'rotate(180deg)'};

  const currentColor = disabled ? colors.lightGrey : color;

  return (
    <div
      className={classes}
      style={{borderColor: currentColor, ...rotate}}
      onClick={onClick}>
      <Icon
        name={Icons.ARROW}
        width="14"
        height="19.44"
        changeViewbox={true}
        color={currentColor}
      />
    </div>
  );
}

export default AppArrowButton;
